import { Injectable } from "@angular/core";
import { checkCurrentID } from "@app/shared/resources/data-actions";
import { EquatorDeviceMetadataService } from "@app/shared/services/equator-api/equator-devices";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action, select, Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { DataActions, DeviceMetadataActions } from "../actions";
import { DeviceMetadataResultPayload } from "../actions/device-metadata.actions";
import { ProjectSelectors } from "../selectors";

@Injectable()
export class DeviceMetadataEffects {
    constructor(private actions$: Actions, public deviceMetadataDbService: EquatorDeviceMetadataService, private readonly store: Store) {}

    getDeviceMetadata$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(DeviceMetadataActions.ActionTypes.GetDeviceMetadata),
            map((action: DeviceMetadataActions.GetDeviceMetadata) => action.payload),
            switchMap(payload =>
                DataActions.toAction()(
                    this.deviceMetadataDbService.get(payload.uuid).pipe(
                        checkCurrentID(this.store.pipe(select(ProjectSelectors.getUuid)), payload.uuid),
                        map(
                            metadata =>
                                ({
                                    uuid: payload.uuid,
                                    result: metadata,
                                } as DeviceMetadataResultPayload)
                        )
                    ),
                    DeviceMetadataActions.GetDeviceMetadataSuccess,
                    DeviceMetadataActions.GetDeviceMetadataFailure
                )
            )
        )
    );
}
